import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { serverResponse } from "./validators";

export async function fetchVouchers() {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/vouchers/referrals?category=trial`,
    {
      method: "get",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
